module.exports = __webpack_public_path__ + "static/img/searchBg.7f0be05f.png";